package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class OffsetPage<T>(
    val data: List<T>,
    val total: Int,
    val offset: Int,
    val limit: Int
)
